import $ from 'jquery';
import { SCENE_EVENTS } from '../MVC/EVENTS/ModelEvents';
import { SCENE_INTERACTION } from '../../constants/scene';
import { toggleSwitch } from '../components';
import WelcomeScreen from '../Modals/WelcomeScreen';
import languages from '../../multiLanguagesController';
import { isMobile } from '../engine/helpers/worldHelpers';
import { LocationMenu } from "./LocationMenu";
import { TourStartMenu } from "./TourStartMenu";
import { WarningIcon } from "../Chat/UI/People";
import { TourModeTimer, TourNameSpan } from "../engine/TourModeWindow";
import { generateIconElement, ICON } from "../Icons/Icons";
import { OwnChairMenu, OwnVapiMenu } from '../Controllers/MeetingMode/MeetingModeView';
import OwnChessMenu from './OwnChessMenu';
import {
  CONFIRM_NOTIFICATION_SIZE,
  CONFIRM_NOTIFICATION_THEME,
  CONFIRM_NOTIFICATION_TYPE
} from "../Modals/Notifications/ConfirmNotification";
import { checkMediaPermissions } from "../engine/helpers/userMediaHelper";
import { BottomNavbarCenterMenu, BottomNavbarRightMenu } from "./BottomNavBarMenu";
import LanguageMenu from './LanguageMenu';
import { FEATURE_NAMES } from "../MVC/rolesHelper";
import { SpaceInfoModal } from "../Modals/Space/SpaceInfoModal";
import multiLanguagesController from '../../multiLanguagesController';
import { NavMenu, NavMenuGroup, NavMenuItem } from "./NavMenu";
import DefaultNavMenu from "./DefaultNavMenu";

export const MOODS = {
  GREEN: "1",
  YELLOW: "2",
  RED: "3",
};

class AppNavMenu extends NavMenu {
  constructor({ model }) {
    super({
      id: 'user-menu',
      items: [
        AppNavMenu.getUserStatusGroup({ model }),
        AppNavMenu.getUserConfigGroup({ model }),
        model.config.isAdmin ? DefaultNavMenu.adminMenuGroup : null,
        DefaultNavMenu.helpAboutGroup,
        model.config.isGuest ?
          AppNavMenu.loginMenuItem :
          AppNavMenu.logoutMenuItem,
      ].filter(Boolean),
    });

    this.model = model;
  }

  init() {
    this.model.addEventListener(SCENE_EVENTS.LANGUAGE_MENU_OPEN, () => {
      AppNavMenu.toggle(true, this.model);
    });
  }

  static toggle(close, model) {
    /** @var AppNavMenu **/
    const controller = $('#user-menu').data('controller');
    if (close) {
      controller?.hide();
    } else {
      if (controller?.isShowing()) {
        controller?.hide();
      } else {
        controller?.show();
      }
    }

    if (close) {
      model && model.dispatchEvent({ type: SCENE_EVENTS.PROFILE_MENU_CLOSE });
    } else {
      model && model.dispatchEvent({ type: SCENE_EVENTS.PROFILE_MENU_OPEN });
    }
  }

  static getUserStatusGroup({ model }) {
    const setMood = (mood) => {
      $("#user_mood").attr('class', `mood_${mood}`);
      $(".mood-radio").text("radio_button_unchecked");
      $(".mood-radio").removeClass("active");
      const target = $(`li#${mood}.navbar-mood.clickable`);
      const active = target.find('.mood-radio');
      active.addClass("active");
      target.find('.mood-radio').html("radio_button_checked");
      model.changeMood(mood);
    }

    return new NavMenuGroup({
      name: 'status',
      title: 'Status',
      titleLangKey: 'user-menu-status',
      items: [
        new NavMenuItem({
          template: `
<li class='nav-menu__group-item navbar-mood clickable' id=${MOODS.GREEN}>
  <div>
    <span class='material-icons md-16 mood-radio active'>radio_button_checked</span>
    <div>
      <span class='mood-description'>Available</span>
      <i class='mood-tag is-primary'></i>
    </div>
  </div>
</li>
          `,
          onClick: () => setMood(MOODS.GREEN),
        }),
        new NavMenuItem({
          template: `
<li class='nav-menu__group-item navbar-mood clickable' id=${MOODS.YELLOW}>
  <div>
    <span class='material-icons md-16 mood-radio'>radio_button_unchecked</span>
    <div>
      <span class='mood-description' data-lang='user-mood-away'>Away</span>
      <i class='mood-tag is-warning'></i>
    </div>
  </div>
</li>
          `,
          onClick: () => setMood(MOODS.YELLOW),
        }),
        new NavMenuItem({
          template: `
<li class='nav-menu__group-item navbar-mood clickable' id=${MOODS.RED}>
  <div>
    <span class='material-icons md-16 mood-radio'>radio_button_unchecked</span>
    <div>
      <span class='mood-description' data-lang='user-mood-dnd'>Do not disturb</span>
      <i class='mood-tag is-danger'></i>
    </div>
  </div>
</li>
          `,
          onClick: () => setMood(MOODS.RED),
        }),
      ]
    })
  }

  static getUserConfigGroup({ model }) {
    return new NavMenuGroup({
      items: [
        new NavMenuItem({
          id: 'editProfile',
          classes: 'editProfile',
          label: 'My profile',
          labelLangKey: 'my-profile-text',
          icon: `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.1666 6.66671C8.1666 5.56214 9.06203 4.66671 10.1666 4.66671C11.2712 4.66671 12.1666 5.56214 12.1666 6.66671C12.1666 7.77128 11.2712 8.66671 10.1666 8.66671C9.06203 8.66671 8.1666 7.77128 8.1666 6.66671ZM10.1666 3.33337C8.32565 3.33337 6.83326 4.82576 6.83326 6.66671C6.83326 8.50766 8.32565 10 10.1666 10C12.0075 10 13.4999 8.50766 13.4999 6.66671C13.4999 4.82576 12.0075 3.33337 10.1666 3.33337ZM7.49996 11.3334C6.6159 11.3334 5.76806 11.6846 5.14294 12.3097C4.51782 12.9349 4.16663 13.7827 4.16663 14.6668V16.0001C4.16663 16.3683 4.4651 16.6668 4.83329 16.6668C5.20148 16.6668 5.49996 16.3683 5.49996 16.0001V14.6668C5.49996 14.1363 5.71067 13.6276 6.08575 13.2526C6.46082 12.8775 6.96953 12.6668 7.49996 12.6668H12.8333C13.3637 12.6668 13.8724 12.8775 14.2475 13.2526C14.6226 13.6276 14.8333 14.1363 14.8333 14.6668V16.0001C14.8333 16.3683 15.1318 16.6668 15.5 16.6668C15.8682 16.6668 16.1666 16.3683 16.1666 16.0001V14.6668C16.1666 13.7827 15.8154 12.9349 15.1903 12.3097C14.5652 11.6846 13.7174 11.3334 12.8333 11.3334H7.49996Z" fill="#A1A7B4"/>
</svg>
          `,
        }),
        new NavMenuItem({
          id: 'mediaSettings',
          label: 'Device settings',
          labelLangKey: 'tune-menu-device-settings',
          icon: `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.44098 10C7.44098 11.5068 8.66144 12.7273 10.1683 12.7273C11.6683 12.7273 12.8955 11.5068 12.8955 10C12.8955 8.4932 11.6751 7.27274 10.1683 7.27274C8.66144 7.27274 7.44098 8.4932 7.44098 10ZM8.80462 10C8.80462 9.25001 9.41826 8.63638 10.1683 8.63638C10.9183 8.63638 11.5319 9.25001 11.5319 10C11.5319 10.75 10.9183 11.3636 10.1683 11.3636C9.41826 11.3636 8.80462 10.75 8.80462 10Z" fill="#A1A7B4"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0182 17.5H10.3182C10.8637 17.5 11.375 17.2886 11.7705 16.9C12.1591 16.5114 12.3705 16 12.3705 15.4545V15.325C12.3705 15.2023 12.3978 15.0864 12.4591 14.9841C12.5205 14.8818 12.6023 14.7932 12.7114 14.7318L13.0046 14.5614C13.2159 14.4455 13.4614 14.4318 13.7069 14.575L13.7887 14.6159C14.2523 14.8818 14.8182 14.9568 15.3364 14.8205C15.8682 14.6841 16.3046 14.3432 16.5841 13.8659L16.7273 13.6068C17 13.1364 17.075 12.5841 16.9319 12.0591C16.7887 11.5341 16.4478 11.0909 15.9569 10.8045L15.875 10.7636C15.7659 10.7023 15.6841 10.6136 15.6228 10.5114C15.5682 10.4023 15.5341 10.2864 15.5341 10.1636V9.82273C15.5273 9.70682 15.5614 9.58409 15.6228 9.48182C15.6841 9.37954 15.7659 9.29773 15.8819 9.22955L15.9841 9.16136C16.4546 8.88864 16.7887 8.44545 16.9319 7.92045C17.075 7.39545 17 6.84318 16.7273 6.37273L16.5773 6.11364C16.3046 5.64318 15.8614 5.30909 15.3364 5.16591C14.8114 5.02273 14.2523 5.09773 13.8023 5.35682L13.6796 5.425C13.4682 5.54091 13.2023 5.54091 12.9978 5.425L12.7046 5.25455C12.5955 5.2 12.5137 5.11136 12.4523 5.00909C12.3978 4.90682 12.3637 4.78409 12.3637 4.66818V4.54545C12.3637 4 12.1523 3.48864 11.7637 3.1C11.375 2.71136 10.8637 2.5 10.3182 2.5H10.0182C9.47277 2.5 8.95459 2.71136 8.57277 3.1C8.18413 3.48864 7.97277 4 7.97277 4.54545V4.66818C7.97277 4.78409 7.93868 4.90682 7.88413 5.00909C7.82277 5.11136 7.73413 5.2 7.63186 5.26136L7.33868 5.425C7.12731 5.54773 6.88186 5.56136 6.62959 5.41818L6.54777 5.37727C6.07731 5.10455 5.52504 5.02955 5.00004 5.17273C4.48186 5.30909 4.02504 5.65682 3.75913 6.12045L3.60913 6.37955C3.3364 6.85 3.26822 7.40227 3.40459 7.92727C3.54777 8.45909 3.88186 8.89545 4.32504 9.15455L4.4614 9.24318C4.56368 9.29773 4.65231 9.38636 4.70004 9.48182C4.75459 9.58409 4.78868 9.7 4.78868 9.81591V10.1705C4.78868 10.2864 4.7614 10.4091 4.70004 10.5114C4.63868 10.6205 4.55686 10.7023 4.44095 10.7705L4.35231 10.825C3.88186 11.0977 3.54777 11.5409 3.40459 12.0659C3.2614 12.5977 3.3364 13.1432 3.60913 13.6205L3.76595 13.8727C4.03186 14.3432 4.48868 14.6841 5.00686 14.8273C5.53186 14.9705 6.08413 14.8955 6.53413 14.6364L6.65686 14.5682C6.86822 14.4523 7.13413 14.4523 7.33868 14.5682L7.63186 14.7386C7.74095 14.8 7.82277 14.8886 7.88413 14.9909C7.93868 15.0932 7.97277 15.2159 7.97277 15.3318V15.4545C7.97277 16 8.18413 16.5114 8.57277 16.9C8.9614 17.2886 9.47277 17.5 10.0182 17.5ZM8.02049 13.3886C7.70686 13.2114 7.35913 13.1159 6.99777 13.1159C6.6364 13.1159 6.28186 13.2114 6.00231 13.3818L5.87959 13.45C5.72277 13.5386 5.53868 13.5659 5.3614 13.5182C5.18413 13.4705 5.03413 13.3545 4.9455 13.1977L4.7955 12.9386C4.70686 12.7818 4.67959 12.5977 4.72731 12.4205C4.77504 12.2432 4.88413 12.0932 5.05459 11.9977L5.14322 11.9432C5.45686 11.7659 5.71595 11.5068 5.89322 11.1932C6.07731 10.8795 6.16595 10.525 6.16595 10.1705V9.81591C6.16595 9.46136 6.06368 9.11364 5.8864 8.8C5.70913 8.48636 5.45004 8.23409 5.17731 8.07727L5.04095 7.98864C4.88413 7.9 4.76822 7.75682 4.72049 7.57955C4.67959 7.40227 4.70004 7.21818 4.78868 7.06136L4.9455 6.80227C5.03413 6.64545 5.18413 6.52955 5.35459 6.48864C5.53186 6.44091 5.71595 6.46136 5.89322 6.56364L5.97504 6.60455C6.58868 6.96591 7.39322 6.96591 8.02049 6.60455L8.31368 6.44091C8.62731 6.25682 8.8864 5.99773 9.06368 5.69091C9.24095 5.37727 9.3364 5.02955 9.3364 4.66818V4.54545C9.3364 4.36818 9.4114 4.19091 9.53413 4.06136C9.66368 3.93864 9.84095 3.86364 10.0182 3.86364H10.3182C10.4955 3.86364 10.6728 3.93864 10.8023 4.06136C10.925 4.19091 11 4.36818 11 4.54545V4.675C11 5.02955 11.0955 5.38409 11.2728 5.69773C11.45 6.00455 11.7091 6.26364 12.0159 6.44091L12.3091 6.61136C12.9296 6.97273 13.7546 6.96591 14.3341 6.625L14.4569 6.55682C14.6137 6.46818 14.8046 6.44091 14.975 6.48864C15.1523 6.53636 15.3023 6.64545 15.3909 6.80227L15.5409 7.06136C15.6296 7.21818 15.6569 7.40909 15.6091 7.57955C15.5614 7.75 15.4523 7.9 15.2887 7.99545L15.1932 8.05C14.8796 8.22727 14.6205 8.48636 14.4432 8.8C14.2659 9.10682 14.1705 9.46818 14.1705 9.82273V10.1636C14.1705 10.5182 14.2659 10.8727 14.4432 11.1864C14.6205 11.5 14.8796 11.7591 15.2137 11.95L15.2955 11.9909C15.4523 12.0795 15.5682 12.2364 15.6159 12.4068C15.6569 12.5841 15.6364 12.7682 15.5409 12.9318L15.3978 13.1909C15.3023 13.3477 15.1591 13.4568 14.9819 13.5045C14.8046 13.5523 14.6137 13.5318 14.4432 13.4295L14.3614 13.3886C13.7409 13.0273 12.9364 13.0273 12.3159 13.3886L12.0228 13.5591C11.7091 13.7432 11.45 13.9955 11.2728 14.3091C11.0955 14.6227 11 14.9773 11 15.3318V15.4545C11 15.6386 10.9319 15.8091 10.8023 15.9386C10.6728 16.0682 10.5023 16.1364 10.3182 16.1364H10.0182C9.83413 16.1364 9.66368 16.0682 9.52731 15.9386C9.39777 15.8091 9.32959 15.6386 9.32959 15.4545V15.325C9.32959 14.9636 9.23413 14.6159 9.05686 14.3023C8.87959 13.9955 8.62049 13.7364 8.31368 13.5591L8.02049 13.3886Z" fill="#A1A7B4"/>
</svg>
          `,
          onClick: () => {
            model.onOpenMediaSettings();
          }
        })
      ]
    })
  }

  static get loginMenuItem() {
    return new NavMenuItem({
      id: 'app-login',
      label: 'Log in',
      labelLangKey: 'user-profile-login',
      onClick: () => {
        if (window.openLoginModal) {
          window.openLoginModal();
        } else {
          window.location.assign(`${window.origin}/user/login`);
        }
      }
    })
  }

  static get logoutMenuItem() {
    return new NavMenuItem({
      label: 'Logout',
      labelLangKey: 'user-profile-logout',
      icon: `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.3751 16.0834C15.5629 16.0834 15.7431 16.0087 15.8759 15.8759C16.0088 15.7431 16.0834 15.5629 16.0834 15.375L16.0834 5.45837C16.0834 5.27051 16.0088 5.09035 15.8759 4.95751C15.7431 4.82467 15.5629 4.75004 15.3751 4.75004L12.5417 4.75004C12.1505 4.75004 11.8334 4.43291 11.8334 4.04171C11.8334 3.65051 12.1505 3.33337 12.5417 3.33337L15.3751 3.33337C15.9386 3.33337 16.4791 3.55726 16.8777 3.95577C17.2762 4.35429 17.5001 4.89479 17.5001 5.45837V15.375C17.5001 15.9386 17.2762 16.4791 16.8777 16.8776C16.4791 17.2762 15.9386 17.5 15.3751 17.5H12.5417C12.1505 17.5 11.8334 17.1829 11.8334 16.7917C11.8334 16.4005 12.1505 16.0834 12.5417 16.0834H15.3751Z" fill="#A1A7B4"/>
  <path d="M8.08425 14.4592C7.80763 14.7359 7.35914 14.7359 7.08252 14.4592L3.54306 10.9198C3.53556 10.9123 3.52822 10.9047 3.52105 10.897C3.46546 10.8368 3.42222 10.7693 3.39133 10.6978C3.35404 10.6116 3.33337 10.5166 3.33337 10.4167C3.33337 10.3167 3.35411 10.2215 3.39151 10.1352C3.4221 10.0645 3.46477 9.99775 3.51952 9.9381C3.5272 9.92972 3.53509 9.92152 3.54317 9.91352L7.08252 6.37417C7.35914 6.09755 7.80763 6.09755 8.08425 6.37417C8.36087 6.65079 8.36087 7.09928 8.08425 7.3759L5.75178 9.70837L12.5417 9.70837C12.9329 9.70837 13.25 10.0255 13.25 10.4167C13.25 10.8079 12.9329 11.125 12.5417 11.125H5.75178L8.08425 13.4575C8.36087 13.7341 8.36087 14.1826 8.08425 14.4592Z" fill="#A1A7B4"/>
</svg>
      `,
      id: 'app-logout',
      onClick: () => {
        $('#logout-form').trigger('submit');
      }
    })
  }
}

class BaglessLogo {
  static template() {
    return `
<div class='bagless_logo returnToWordpress'>
  <img src='/textures/bagless_logo.svg' id='bagless_logo' />
</div>
`
  }

  static simpleUITemplate() {
    return `
<section class="returnToWordpress world-top-nav__logo_area__logo">
  <img src="/textures/bagless_logo.png" alt="bagless.io">
</section>
`
  }

  static init({ model }) {
    $(document).on('click', '.returnToWordpress', (e) => {
      if (model.isEmbed === "0") {
        window.location.href = "/";
        return;
      }
      model.confirm($trans('exit-app-confirm'), () => {
        if (model.customBack) {
          window.close()
          return
        }
        e.stopPropagation()
        window.location.assign(window.origin)
      }, {
        confirmBtnTxt: 'Exit',
        modalTheme: CONFIRM_NOTIFICATION_THEME.DARK,
        modalType: CONFIRM_NOTIFICATION_TYPE.WARNING,
        modalSize: CONFIRM_NOTIFICATION_SIZE.SM,
      });
    });
  }
}

const guided_mode_banner = `
  <div class='guided_mode_banner hidden' id='guided_mode_banner' style="display: none;">
    <span>You are Tour Guide</span>
  </div>
`;
const tour_mode_banner = `
  <div class='guided_mode_banner hidden' id='tour_mode_banner' style="display: none;">
  <span>You are Tour Guest</span>
    <div id="tour-contributore-wrapper"></div>
  </div>
`;
const assistant_mode_banner = `
  <div class='guided_mode_banner hidden' id='assist_mode_banner' style="display: none;">
  <span>You are Tour Assistant</span>
    <div id="tour-contributore-wrapper"></div>
  </div>
`;

class UserProfile {
  static template() {
    return `
<div class='user-profile-trigger avatar_holder'>
  <div class='round-wrapper'>
    <img src="./textures/empty.png" class='local-avatar' alt="Image" onError='this.src = "textures/defaultAvatar.png"'>
    <div class='local-video video-wrapper'>
     <!-- <video id="localVideo" class='already-muted' autoplay muted playsinline></video> -->
      <div class="videoLabel" data-user-name="" data-user-id=""></div>
    </div>
  </div>
  <span id='user_mood' class='mood_1'></span>
</div>   
`
  }

  static simpleUITemplate() {
    return `
  <div class="world-top-nav__menu_area__image_wrapper">
    ${ICON.THREE_DOTS}
    <img
      src="/textures/icons/icon_menu.svg"
      alt="Menu"
      class="icon_menu"
    >
  </div>
  <div>
    <img
      class="local-avatar"
      src="/textures/icons/icon_avatar.svg"
      alt="User avatar"
    >
  </div>
`
  }

  static init({ model }) {
    $(".local-avatar").attr('src', model.config.userAvatarUrl);

    model.addEventListener(SCENE_INTERACTION.USER_AVATAR_CHANGED, (e) => {
      if (e.data.userAvatarUrl) {
        $('.local-avatar').attr('src', e.data.userAvatarUrl);
      }
    });
  }

  static onClick(handler) {
    $(document).on('click', '.user-profile-trigger', handler)
  }
}

class ShareLocation {
  static template() {
    return `<span class='material-icons md-26 clickable' id='shareToggle'>share_location</span>`
  }

  static init({ model }) {
    $("#shareToggle").on("click", () => {
      navigator.clipboard.writeText(window.location.href);
      $("#world-url").val(window.location.href);

      $(".share-form").addClass('is-active');

      if (!this.qrcode) {
        this.qrcode = new QRCode(document.getElementById("qrcode"), {
          text: window.location.href,
          width: 128,
          height: 128,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H
        });
      }
    })
    if (!model.sceneData.publicAvailable || (model.sceneData.publicAvailable && (model.sceneData.publicAvailable !== 1))) {
      $("#shareToggle").hide();
    }
  }
}

// const tourMode = `
// <div class="toolbar-hover">
//   <span class="tooltip top-caret" data-lang="tour-mode-text">Tour mode</span>
//   <span class='material-icons md-26 clickable' id='guideButton'>ads_click</span>
// </div>`;
const tourMode = ``;
class TuneIcon {
  static template() {
    return `<span class='material-icons clickable tobehide' id='tuneSettings'>tune</span>`
  }

  static simpleUITemplate() {
    return `
<div id="tuneSettings" class="world-bottom-nav__area__item">
  ${ICON.BARS}
</div>
`
  }

  static onClick(handler) {
    $(document).on("click", "#tuneSettings", handler);
  }

  static triggerClick() {
    $('#tuneSettings').trigger('click')
  }
}

class FullScreenIcon {
  static simpleUITemplate() {
    return `
      <div id="fullscreen_toggle" class="world-bottom-nav__area__item">
        ${ICON.FULL_SCREEN_TOGGLE}
      </div>
    `
  }
}
class GuideModeIcon {
  static simpleUITemplate(model) {
    const disabledClass = model?.sceneData?.tourModeAvailable === 0 ? ' look-disabled' : '';
    return `
      <div id="guideButton" class="world-bottom-nav__area__item${disabledClass}">
        ${ICON.TOUR}
      </div>
    `
  }
}
class InfoIcon {
  static simpleUITemplate() {
    return `
      <div id="infoButton" class="world-bottom-nav__area__item">
        ${ICON.INFO}
      </div>
    `
  }
}
class LocationsIcon {
  static simpleUITemplate() {
    return `
      <div id="locationsButton" class="world-bottom-nav__area__item icon-compass">
        ${ICON.COMPASS}
      </div>
    `
  }
}

class BurgerMenu {
  static template() {
    return `<span class='material-icons clickable' id='burger-menu'>menu</span>`
  }

  static init({ model }) {
    $("#burger-menu").on("click", () => {
      model.onNavbarOpen();
      TuneIcon.triggerClick()
    });
  }
}
const editIcon = `<span class='material-icons clickable tobehide hidden' id='toggleModes'>edit</span>`;
const exitApp = `<span class='material-icons clickable tobehide' id='exit_app'>exit_to_app</span>`;
const simpleUIExitApp = `
<div id="exit_app" class="world-bottom-nav__area__item world-bottom-nav__area__exit">
  ${ICON.EXIT}
</div>
`;
const divider = `<span class='divider tobehide'>|</span>`;
const leavePreviewMode = `<span class='leave_preview_mode buttn secondary' data-lang='leave-preview-text'>Leave preview</span>`;
class LeavePreviewMode {
  static template() {
    return `<span class='leave_preview_mode buttn secondary' data-lang='leave-preview-text'>Leave preview</span>`
  }

  static simpleUITemplate() {
    return `
<div
  class="world-bottom-nav__area__item world-bottom-nav__area__leave-preview-mode"
  data-lang="leave-preview-text"
>
  Leave preview
</div>`
  }

  static init({ model }) {
    $(".leave_preview_mode, .world-bottom-nav__area__leave-preview-mode").toggleClass('visible', model.previewMode);
  }
}

const help = `<span class='material-icons clickable usetiful_help tobehide' id='usetiful_help'>help_outline</span>`;

class ParticipantMode {
  static template() {
    return `
<div class="world-bottom-nav__area__item world-bottom-nav__area__enter-normal-mode">
  <span class="world-bottom-nav__area__enter-normal-mode__text">Aktiv teilnehmen</span>
  <div class="world-bottom-nav__area__enter-normal-mode__icons">
    ${ICON.CAMERA_OFF}
    ${ICON.MIC_OFF}
  </div>
</div>    
`
  }

  /**
   * @param {Model} model
   */
  static async init({ model }) {
    $(document).on('click', '.world-bottom-nav__area__enter-normal-mode', (e) => {
      model.dispatchEvent({ type: SCENE_EVENTS.OPEN_MEDIA_SETTINGS, data: { showPermissionPrompt: false } });
    })

    if (await checkMediaPermissions()) {
      this.hideButton()
    }
  }

  static hideButton() {
    $('.world-bottom-nav__area__enter-normal-mode').addClass('is-hidden')
  }
}

export class WorldName {
  static template() {
    return `
<div class="world_names">
  <span id="room_name" data-id=''></span>
  <span id='world_names_divider'>/</span>
  <span id="location_name" data-id=''></span>
</div>
`
  }

  static simpleUITemplate() {
    return `
<div class="world-bottom-nav__area__item world-bottom-nav__area__location">
  ${ICON.INFO}
  <div class="divider"></div>
  <div class="world-bottom-nav__area__location__name" data-id=''>
    ${TourModeTimer.template()}
    <span id="room_name" data-id=''></span>
    <span id='world_names_divider'> | </span>
    <span id="location_name" data-id='' data-tour-mode-display="0"></span>
    ${TourNameSpan.template()}
  </div>
  <div class="divider"></div>
  ${ICON.COMPASS}
</div>    
`
  }

  static onClick(handler) {
    $(document).on("click", "#location_name", handler);
  }
}

class TuneMenu {
  constructor({ model, isMobile }) {
    this.model = model
    this.isMobile = isMobile
    this.$tuneMenu = $("#tuneMenu")
    this.isOpened = false;
    // Initialize SpaceInfoModal
    this.spaceInfoModal = new SpaceInfoModal({
      model: this.model,
      socket: this.model.socket || null
    });

    this.init();
    // Gyro only applies on phones. Keep the switch available there so it can be turned off.
    if (this.isMobile) {
      $("#device-orientation-container").show();
    } else {
      $("#device-orientation-container").hide();
    }

    $(".world-bottom-nav__area__item")
      .on("click", () => {
        $("#tuneMenu").trigger('toggle', false);
      });
  }

  static toggle(isShow = null) {
    $("#tuneMenu").trigger('toggle', isShow);
  }

  toggle(isShow = null) {
    if (isShow === null) {
      isShow = !this.isOpened
    }
    if (isShow) {
      this.model.onNavbarOpen();
    }
    AppNavMenu.toggle(true, this.model)
    this.$tuneMenu.toggleClass("is-active", isShow);
    this.isOpened = isShow;
  }

  onToggle(e, close) {
    // if (this.model.isEmbed === "1") {
    //   e.preventDefault();
    //   e.stopPropagation();
    //   $(".join-guest-header").hide();
    //   $(".edit_profile_holder").toggleClass("is-active", !$(".edit_profile_holder").hasClass("is-active"));
    //   if (close) {
    //     $(".edit_profile_holder").removeClass("is-active")
    //   }
    //   return;
    // }

    AppNavMenu.toggle(close, this.model);

    this.$tuneMenu.removeClass("is-active");
    this.isOpened = false
    this.model.onNavbarOpen();
  }

  init() {
    this.$tuneMenu.on("toggle", (e, isShow) => {
      this.toggle(isShow);
    });

    $(document).on('click', '#guideButton', (e) => {
      this.onToggle(e, true)
    });
    $(document).on('click', '#infoButton', (e) => {
      $("#showSpaceInfo").trigger('click');
    });
    $(document).on('click', '#locationsButton', (e) => {
      if ($(e.currentTarget).hasClass('disabled')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      this.model.dispatchEvent({ type: SCENE_EVENTS.TOGGLE_LOCATION_MENU });
    });

    $(document).on("click", "#closeTuneMenu", () => {
      this.model.onNavbarOpen();
      TuneIcon.triggerClick()
    });

    $(document).on('click change', '#toggleElementsVisibility', (e) => {
      const checked = $(e.target).prop('checked');
      this.model.showElements = checked;
      checked ? this.model.showSceneElements() : this.model.hideSceneElements();
      $(".indicator").toggleClass('hideElements', !checked);
    });

    $(document).on("click", "#backToWorldsMenu", () => {
      if (this.model.customBack) {
        window.close();
        return;
      }
      window.location.assign(window.origin);
    });

    $("#oneClickTakeSeat").on("click", (e) => {
      // Copy the URL with the specified parameter to the clipboard
      navigator.clipboard.writeText(`${window.location.href}&autoseat=true`).then(() => {
        // Optional: Provide visual feedback to the user
        this.model.alert('success', $trans('success-world-name-copied'));
        this.onToggle(e, true)
      }).catch(err => {
        console.error("Failed to copy text: ", err);
      });
    });

    $(document).on("click", "#open-setting-menu", (e) => {
      this.onToggle(e, true)
      this.model.dispatchEvent({ type: SCENE_EVENTS.OPEN_SETTING_MENU });
    });
    $(document).on("click", "#showSpaceInfo", (e) => {
      this.onToggle(e, true)
      if (this.spaceInfoModal) {
        this.spaceInfoModal.show();
      }
    });

    $(document).on("click", "#editRoom", (e) => {
      this.onToggle(e, true)
      // Trigger edit room functionality
      this.model.dispatchEvent({ type: "EDIT_ROOM" });
    });

    $(document).on("click", "#toggleLock", async (e) => {
      if (!await this.model.validatePlanFeature(FEATURE_NAMES.LOCK_ROOM)) {
        e.preventDefault();
      }
    });
    $(document).on("change", "#toggleLock", async (e) => {
      if (!await this.model.validatePlanFeature(FEATURE_NAMES.LOCK_ROOM)) {
        return;
      }

      $(e.target).prop('checked') ? this.model.lockScene() : this.model.unlockScene();
    });

    $(document).on("click", '#help_center, .bagless-help-center-trigger', (e) => {
      this.toggle(false)
      if (typeof window.openBaglessHelpCenter === 'function') {
        window.openBaglessHelpCenter(e);
      }
    })

    // this.isLockableScene();

    this.model.addEventListener(SCENE_EVENTS.SCENE_CHANGED, (e) => {
      this.handleLockUnlockScene();

      // Refresh space info if modal is open
      if (this.spaceInfoModal && this.spaceInfoModal.isVisible()) {
        this.spaceInfoModal.refresh();
      }
    });
    this.model.addEventListener(SCENE_INTERACTION.SET_LOCKED_ROOMS, (e) => {
      this.handleLockUnlockScene();
    });

    this.handleLockUnlockScene();
    this.isLockableScene();
    // $("#lock-location-option").toggleClass("disabled", !model.isSceneLockable[model.currentScene.id]);
  }

  handleLockUnlockScene() {
    const { lockedRooms } = this.model;
    const { id } = this.model.currentScene;
    this.showLock();
    if (lockedRooms && lockedRooms[id]) {
      this.showUnlock();
    }
    this.isLockableScene();
  }

  isLockableScene() {
    const { id } = this.model.currentScene;
    const isLockable = this.model.isSceneLockable(id);
    /// if scene is unabled to lock
    if (!isLockable) {
      $("#lock-location-option").addClass("disabled");
      $("#toggleLock").prop("checked", false);
    }
  }

  showLock() {
    $("#lock-location-option").removeClass("disabled");
    $("#toggleLock").prop("checked", false);
  }

  showUnlock() {
    $("#lock-location-option").removeClass("disabled");
    $("#toggleLock").prop("checked", true);
  }

  static template() {
    return `
<ul class='bagless-dropdown-menu' id='tuneMenu'>
  <li id="showSpaceInfo" class="clickable">
  <span data-lang="show-space-info">Show space info</span>
  </li>
  <li class="tune-menu-title">
    <span data-lang="tune-menu-space-settings" class="tune-menu-title">Space Settings</span>
  </li>
  <li id="welcome-screen-option" class='disabled'>
    <div>
      <span class="mr-2" data-lang="tune-menu-welcome-screen">Welcome screen</span>
      ${toggleSwitch('showWelcomeScreen')}
    </div>
  </li>
  <li id="device-orientation-container">
    <div>
      <span class="mr-2" data-lang="device-orientation-controller">Orientation control</span>
      ${toggleSwitch('useDeviceOrientation')}
    </div>
  </li>
  <li>
    <div>
      <span class="mr-2" data-lang="tune-menu-ambient-music">Ambient music</span>
      <input type='hidden' id='ambientMusicVolume' value='0.5' />
      ${toggleSwitch('ambientMusic')}
    </div>
  </li>
  <li>
    <div>
      <span class="mr-2" data-lang="tune-menu-elements-visible">Elements visible</span>
      ${toggleSwitch('toggleElementsVisibility')}
  </div>
  </li>
  <li class='clickable bagless-help-center-trigger' id='help_center'>
    <span data-lang="help-center-text">Help Center</span>
  </li>
  <li class='clickable leave_preview_mode'>
    <span data-lang="leave-preview-text">Leave preview</span>
  </li>
  <hr class='mobileOnly'></hr>
  <li id='closeTuneMenu' class='clickable mobileOnly'>
    <span data-lang="close-text">Close</span>
  </li>
</ul>
`
  }
}

class FoldableColumnMenu {
  constructor(id, onToggle = () => { }) {
    this.tempate = $(document.getElementById(id));
    this.$template = $(this.tempate, {
      id,
    })

    this.$elements = {
      content: this.$template.find('.world-bottom-nav__foldable__content'),
      trigger: this.$template.find('.world-bottom-nav__foldable__trigger'),
    }

    this.isShowing = false
    this.isFoldable = true
    this.onToggle = onToggle
  }

  static generateTemplate(id, slot, icon, className = '') {
    return `<div id="${id}" class="world-bottom-nav-inner-wrapper world-bottom-nav__foldable ${className}">
      <div class="world-bottom-nav__foldable__content is-hide">
        ${slot}
      </div>
      <div class="world-bottom-nav__area world-bottom-nav__foldable__trigger-wrapper">
        <div class="world-bottom-nav__area__item world-bottom-nav__foldable__trigger">
          ${icon}
        </div>
      </div>
    </div>`
  }

  init() {
    this.addEventListeners()
  }

  addEventListeners() {
    this.$elements.trigger.on("click", () => {
      this.toggleFoldableMenu()
    })

    $(document).on("click", (e) => {
      if (this.isShowing && !this.$elements.trigger.is(e.target) && !this.$elements.trigger.has(e.target).length) {
        this.toggleFoldableMenu(false)
      }
    })

    $(document).on("click", '#usetiful_help', (e) => {
      this.toggleFoldableMenu(false)
    })
  }

  toggleFoldableMenu(isShow = null) {
    if (isShow === null) {
      isShow = !this.isShowing
    }
    if (isShow) {
      this.$elements.content.addClass('is-active');
      this.$elements.trigger.addClass('is-active');
      this.$elements.content.removeClass('is-hide')
    } else {
      this.$elements.content.removeClass('is-active');
      this.$elements.trigger.removeClass('is-active');
      setTimeout(() => {
        this.$elements.content.addClass('is-hide')
      }, 200)
    }
    this.isShowing = isShow
    this.onToggle?.(isShow);
  }

  toggleFoldable(isFoldable = null) {
    if (isFoldable === null) {
      isFoldable = !this.isFoldable
    }
    if (isFoldable) {
      this.$template.removeClass('is-disable-foldable');
    } else {
      this.$template.addClass('is-disable-foldable');
    }
    this.isFoldable = isFoldable
  }
}

export class DefaultControlMenu extends BottomNavbarCenterMenu {
  static selector() {
    return $('#world-button-nav__default')
  }

  static template(model) {
    return `
<div class="world-bottom-nav-inner-wrapper">
  <section id="world-button-nav__default" class="world-bottom-nav__area world-bottom-nav__center_area">
    ${ParticipantMode.template(model)}
    ${LeavePreviewMode.simpleUITemplate()}
    ${simpleUIExitApp}
  </section>
</div>
    `
  }
}

export class DefaultRightControlMenu extends BottomNavbarRightMenu {
  static selector() {
    return $('#world-button-nav__default-right')
  }

  static template(model) {
    return `
      <section class="world-bottom-nav__area world-bottom-nav__right_area" id="world-button-nav__default-right">
        ${CreatePostitButton.template()}
        <div class="world-bottom-nav__area__item world-bottom-nav__area__chat" id="chat-list-navbar-button">
          ${ICON.CHAT}
          <div
            id="chat-list-total-badge"
            class="world-bottom-nav__area__chat__badge"
          ></div>
        </div>
        <div class="world-bottom-nav__area__item world-bottom-nav__area__people" id="people-list-navbar-button">
          ${ICON.PEOPLE}
          <div class="world-bottom-nav__area__people__warning-icon scale-up-center">
            ${WarningIcon()}
          </div>
          <div class="world-bottom-nav__area__people__count">
            0
          </div>
        </div>
      </section>
    `
  }
}

export class CreatePostitButton {
  static template() {
    return `
    <div class="world-bottom-nav__area__item world-bottom-nav__area__create-postit" id="create-postit-button">
      ${ICON.PLUS}
    </div>
    `
  }
}

const template = `
<div class="navbar-holder">
  <div id="navbar-holder">
    <section class='left-nav-side'>
      ${BurgerMenu.template()}
      ${exitApp}
      ${divider}
      ${TuneIcon.template()}
      ${WorldName.template()}
    </section>
    <section class='middle-nav'>
      ${BaglessLogo.template()}
      ${guided_mode_banner}
      ${tour_mode_banner}
      ${assistant_mode_banner}
    </section>
    <section class='right-nav-side'>
      ${LeavePreviewMode.template()}
      ${tourMode}
      ${editIcon}
      ${UserProfile.template()}
    </section>
  </div>
</div>
${TuneMenu.template()}
`;

// Add language button template before the topNavbarTemplate
const languageButton = `
  <div class="language-button world-top-nav__menu_area">
    ${ICON.GLOBE}
    <div class="language-menu-dropdown"></div>
  </div>
`;

const pageMuteButton = `
  <div class="page-mute-button world-top-nav__menu_area" id="page_media_mute_toggle" role="button" tabindex="0" aria-label="">
    <span class="material-icons-outlined page-mute-button__icon page-mute-button__icon--on" aria-hidden="true">volume_up</span>
    <span class="material-icons-outlined page-mute-button__icon page-mute-button__icon--off" aria-hidden="true">volume_off</span>
  </div>
`;

const fullScreenButton = `
  <div class="full-screen-button world-top-nav__menu_area" id="fullscreen_toggle">
    ${ICON.FULL_SCREEN_TOGGLE}
  </div>
`;

const topNavbarTemplate = `
  <div id="world-top-nav" class="world-top-nav">
    <section class="world-top-nav__logo_area">
      ${BaglessLogo.simpleUITemplate()}
    </section>

    <section class="world-top-nav__guided_mode_area">
      ${guided_mode_banner}
      ${tour_mode_banner}
      ${assistant_mode_banner}
    </section>
      ${languageButton}
      ${pageMuteButton}
      ${fullScreenButton}
    <section class="world-top-nav__menu_area user-profile-trigger" id="user-menu-toggle">
      ${UserProfile.simpleUITemplate()}
    </section>
  </div>
`;

export class BottomNavBar {
  static template(model) {
    return `
<div id="world-bottom-nav" class="world-bottom-nav">
  ${FoldableColumnMenu.generateTemplate(
      'world-bottom-nav__left-area',
      `
      <section class="world-bottom-nav__area world-bottom-nav__left-area">
        ${TuneIcon.simpleUITemplate()}
        ${WorldName.simpleUITemplate()}
        ${GuideModeIcon.simpleUITemplate(model)}
        ${InfoIcon.simpleUITemplate()}
        ${LocationsIcon.simpleUITemplate()}
      </section>
    `,
      ICON.BARS,
      'world-bottom-nav-inner-wrapper--limit-width'
    )}
  
  ${DefaultControlMenu.template(model)}
  
  ${FoldableColumnMenu.generateTemplate(
      'world-bottom-nav__right-area',
      DefaultRightControlMenu.template(),
      ICON.BARS,
      'world-bottom-nav-inner-wrapper--limit-width'
    )}
  
  ${TuneMenu.template()}
  ${LocationMenu.template()}
  ${TourStartMenu.template()}
</div>
`
  }

  static init() {
    setInterval(() => {
      this.checkBottomNavCenterPosition()
    }, 2000)
  }

  static checkBottomNavCenterPosition() {
    const $leftSection = $('#world-bottom-nav__left-area .world-bottom-nav__left-area');
    const $centerSection = $('.world-bottom-nav__center_area:visible');
    const $centerSectionContainer = $centerSection.parent()

    // Check if center section is visible
    if ($centerSection.length) {
      const leftRect = $leftSection[0].getBoundingClientRect();
      const centerRect = $centerSection[0].getBoundingClientRect();
      const screenCenter = window.innerWidth / 2;

      // Check if left section and center section are overlap
      $centerSectionContainer.toggleClass('world-bottom-nav__center_area--absolute', (leftRect.right <= (screenCenter - centerRect.width / 2)) && window.innerWidth > 600)
    }
  }
}

class Navbar {

  /**
   * @param {Model} model
   */
  constructor({ model }) {
    this.model = model;
    this.isMobile = isMobile();

    this.userId = model.config.userId;
    this.userName = model.config.userName;

    if (!model.editMode) {
      this.topNavWrapper = $(topNavbarTemplate)
      this.bottomNavWrapper = $(BottomNavBar.template(model))

      $(document.body).append(this.topNavWrapper)
      $(document.body).append(this.bottomNavWrapper)

      BottomNavBar.init();
      this.bottomLeftFoldableMenu = new FoldableColumnMenu('world-bottom-nav__left-area');
      this.bottomLeftFoldableMenu.init();
      this.bottomLeftFoldableMenu.toggleFoldable(true);

      this.bottomRightFoldableMenu = new FoldableColumnMenu('world-bottom-nav__right-area');


      this.bottomRightFoldableMenu.init()
      this.bottomRightFoldableMenu.toggleFoldable(this.isMobile)

      this.enableChessModeNavbar = () => {
        this.bottomRightFoldableMenu.toggleFoldable(true)
        $('#guideButton').hide()
      }
      this.disableChessModeNavbar = () => {
        this.bottomRightFoldableMenu.toggleFoldable(false)
        $('#guideButton').show()
      }
    } else {
      this.wrapper = $(template);
      $(document.body).append(this.wrapper);

      this.wrapper.find(".menu-button").on("click", (e) => this.tuneMenu.onToggle(e))
      this.wrapper.find("a").on("click", (e) => this.tuneMenu.onToggle(e))
    }

    UserProfile.init({ model });

    this.languageMenu = new LanguageMenu({ model });

    // Add click handler for language button
    $('.language-button').on('click', (e) => {
      e.preventDefault();
      LanguageMenu.toggle(false, model);
    });

    this.appNavMenu = new AppNavMenu({ model });
    this.appNavMenu.init();
    this.appNavMenu.registerAsMainMenu({
      triggerEl: $('#user-menu-toggle'),
      position: 'bottom-end',
    })

    this.ownChairMenu = new OwnChairMenu({ model });
    this.ownVapiMenu = new OwnVapiMenu({ model });
    this.ownChessMenu = new OwnChessMenu({ model, navbar: this });

    $(document).on('click', '.media-settings-form .select-items', () => {
      $("#submit_media_settings").removeClass('disabled');
    });

    $('#copyWorldName').on('click', (e) => {
      this.model.alert('success', $trans('success-world-name-copied'));
      $(".share-form").removeClass('is-active');
    });

    $(document).on('click', '.world-bottom-nav__area__location .icon-info', (e) => {
      e.preventDefault();
      e.stopPropagation();
      TuneIcon.triggerClick();
      $('#showSpaceInfo').trigger('click');
    });
    $(document).on('click', '.world-bottom-nav__area__location .icon-compass', (e) => {
      if ($(e.currentTarget).hasClass('disabled') || $('#locationsButton').hasClass('disabled')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      this.model.dispatchEvent({ type: SCENE_EVENTS.TOGGLE_LOCATION_MENU });
    });

    ShareLocation.init({ model })

    this.tuneMenu = new TuneMenu({ model, isMobile: this.isMobile })

    TuneIcon.onClick(() => this.tuneMenu.toggle())

    // WorldName.onClick((e) => { this.tuneMenu.onToggle(e, true) });

    ParticipantMode.init({ model })
    LeavePreviewMode.init({ model })

    BurgerMenu.init({ model })

    UserProfile.onClick((e) => this.tuneMenu.onToggle(e))
    $("#css3d").on("click", (e) => this.tuneMenu.onToggle(e, true))

    BaglessLogo.init({ model })

    this.model.welcomeScreen = new WelcomeScreen(this.model);
  };
}

export {
  Navbar,
  ParticipantMode,
  FoldableColumnMenu,
}
